import React from "react";
import cx from "classnames";

import { FieldSelector } from "@common/components/FieldSelector";
import { useSkipLogicController } from "./skip-logic.controller";
import { SkipLogicProps } from "./skip-logic.types";

import { SkipLogicControls } from "./components/controls";
import { SkipLogicBody } from "./components/body";
import { SkipLogicHeader } from "./components/header";

import "./skip-logic.styles.scss";

export const SkipLogic: React.FC<SkipLogicProps> = (props) => {
  const { className, disabled, conditions, getFolders, multiple = true } = props;

  const {
    foldersSelectorOpened,
    selectedConditionId,
    handleCloseFoldersSelector,
    handleConditionAdd,
    handleConditionSelect,
    handleGetFields,
    columns,
    processedControls,
  } = useSkipLogicController(props);

  return (
    <div className={cx("SkipLogic", { ["SkipLogic--disabled"]: disabled }, className)}>
      {foldersSelectorOpened && (
        <FieldSelector
          withSearch
          getFolders={getFolders}
          getFields={handleGetFields}
          onChange={handleConditionAdd}
          close={handleCloseFoldersSelector}
          closeOnChange={false}
          multiple={multiple}
        />
      )}
      <div className="SkipLogic__table-wrapper">
        <table className="SkipLogic__table">
          <SkipLogicHeader className="SkipLogic__table__header" columns={columns} />
          <SkipLogicBody
            columns={columns}
            conditions={conditions}
            selectedConditionId={selectedConditionId}
            onConditionClick={handleConditionSelect}
          />
        </table>
      </div>
      {Boolean(processedControls.length) && <SkipLogicControls controls={processedControls} />}
    </div>
  );
};
